import { put, call, all, takeLatest, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneContent,
  GET_ONE_CONTENT,
  GET_ONE_CONTENT_ERROR,
  GET_ONE_CONTENT_SUCCESS,
} from '../types/content/get-one'

import {
  GetAllContents,
  GET_ALL_CONTENTS,
  GET_ALL_CONTENTS_ERROR,
  GET_ALL_CONTENTS_SUCCESS,
  UPDATE_CONTENTS,
} from '../types/content/get-all'

import {
  NewContent,
  NEW_CONTENT,
  NEW_CONTENT_ERROR,
  NEW_CONTENT_SUCCESS,
} from '../types/content/new'

import {
  EditContent,
  EDIT_CONTENT,
  EDIT_CONTENT_ERROR,
  EDIT_CONTENT_SUCCESS,
} from '../types/content/edit'

import {
  DeleteContent,
  DELETE_CONTENT,
  DELETE_CONTENT_ERROR,
  DELETE_CONTENT_SUCCESS,
} from '../types/content/delete'
import { SHOW_CONTENT, SHOW_CONTENT_ERROR, SHOW_CONTENT_SUCCESS, ShowContent } from '../types/content/show'

const currentContentTypeChildren = ({ contentStore }) => contentStore.all.data

function* getOneContent({ payload }) {
  try {
    const { response, error } = yield call(services.content.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_CONTENT_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_CONTENT_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_CONTENT_ERROR,
      payload: 'Error al obtener contendio',
    })
  }
}

function* getAllContents({ payload }) {
  try {
    const { response, error } = yield call(services.content.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_CONTENTS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_CONTENTS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_CONTENTS_ERROR,
      payload: 'Error al obtener los contenidos',
    })
  }
}

function* newContent({ payload }) {
  try {
    const { response, error } = yield call(services.content.new, payload)
    if (error) {
      yield put({
        type: NEW_CONTENT_ERROR,
        payload: error,
      })
    } else {
      const currentContents = yield select(currentContentTypeChildren)

      yield all([
        put({
          type: NEW_CONTENT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_CONTENTS,
          payload: [...(currentContents ? currentContents : []), response],
        }),
      ])
    }
  } catch {
    yield put({
      type: NEW_CONTENT_ERROR,
      payload: 'Error al crear nuevo contenido',
    })
  }
}

function* editContent({ payload }) {
  try {
    const { response, error } = yield call(services.content.edit, payload)
    if (error) {
      yield put({
        type: EDIT_CONTENT_ERROR,
        payload: error,
      })
    } else {
      const currentContents = yield select(currentContentTypeChildren)
      const updatedContents = currentContents?.data?.map(content => {
        if (content?._id === response?._id) {
          return response
        } else {
          return content
        }
      })

      yield all([
        put({
          type: EDIT_CONTENT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_CONTENTS,
          payload: updatedContents,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_CONTENT_ERROR,
      payload: 'Error al editar el contenido.',
    })
  }
}

function* deleteContent({ payload }) {
  try {
    const { response, error } = yield call(services.content.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_CONTENT_ERROR,
        payload: error,
      })
    } else {
      const currentContents = yield select(currentContentTypeChildren)
      const updatedContents = currentContents?.data?.map(content => {
        if (content?._id === response?._id) {
          return response
        } else {
          return content
        }
      })

      yield all([
        put({
          type: DELETE_CONTENT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_CONTENTS,
          payload: updatedContents,
        }),
      ])
    }
  } catch {
    yield put({
      type: DELETE_CONTENT_ERROR,
      payload: 'Error al eliminar contenido',
    })
  }
}


function* showContent({ payload }) {
  try {
    const { response, error } = yield call(services.content.edit, payload)
    if (error) {
      yield put({
        type: SHOW_CONTENT_ERROR,
        payload: error,
      })
    } else {

      const currentContents = yield select(currentContentTypeChildren)

      const updatedContents = currentContents?.[0]?.results?.map((content) => {

        if (content?._id === response?._id) {
          return { ...response, createdBy: content?.createdBy }
        } else {
          return content
        }
      })

      yield all([
        put({
          type: SHOW_CONTENT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_CONTENTS,
          payload: [{ ...currentContents[0], results: updatedContents }],
        }),
      ])
    }
  } catch {
    yield put({
      type: SHOW_CONTENT_ERROR,
      payload: 'Error al cambiar el estado del contenido',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneContent>(GET_ONE_CONTENT, getOneContent)
  yield takeLatest<GetAllContents>(GET_ALL_CONTENTS, getAllContents)
  yield takeLatest<NewContent>(NEW_CONTENT, newContent)
  yield takeLatest<EditContent>(EDIT_CONTENT, editContent)
  yield takeLatest<DeleteContent>(DELETE_CONTENT, deleteContent)
  yield takeLatest<ShowContent>(SHOW_CONTENT, showContent)
}
